const initSafariVideoFix = () => {
  document.querySelectorAll('.kt-video-component[data-autoplay="true"]').forEach(component => {
    const video = component.querySelector('video');
    if (!video) return;
    
    const check = setInterval(() => {
      if (!video.paused && !video.ended && video.readyState > 2) {
        component.classList.add('kt-video-playing');
        clearInterval(check);
      }
    }, 100);

    setTimeout(() => clearInterval(check), 3000);
  });
};

document.addEventListener('DOMContentLoaded', () => {

  let isMobile = window.innerWidth < 767;

  const preloadObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target.querySelector('.kt-hover-video');
        if (video && video.dataset.src && !video.src) {
          video.src = video.dataset.src;
          video.load();
        }
      }
    });
  }, { rootMargin: '200px' });

  const mobileObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!isMobile) return;
      const video = entry.target.querySelector('.kt-hover-video');
      if (!video) return;
      if (entry.isIntersecting) {
        if (!video.dataset.played) {
          video.dataset.played = 'true';
          video.play();
          video.addEventListener('ended', () => {
            video.pause();
          }, { once: true });
        }
      } else {
        video.pause();
      }
    });
  }, { threshold: 1.0 });

  document.querySelectorAll('.kt-product-image__has-hover-video').forEach(card => {
    preloadObserver.observe(card);
    mobileObserver.observe(card);
  });

  document.addEventListener('mouseover', (e) => {
    if (isMobile) return;
    const card = e.target.closest('.kt-product-image__has-hover-video');
    if (!card) return;
    const video = card.querySelector('.kt-hover-video');
    if (!video) return;
    video.play();
  });

  document.addEventListener('mouseout', (e) => {
    if (isMobile) return;
    const card = e.target.closest('.kt-product-image__has-hover-video');
    if (!card) return;
    if (card.contains(e.relatedTarget)) return;
    const video = card.querySelector('.kt-hover-video');
    if (!video) return;
    video.pause();
  });

  window.addEventListener('resize', () => {
    isMobile = window.innerWidth < 767;
    document.querySelectorAll('.kt-hover-video').forEach(video => {
      video.pause();
      video.currentTime = 0;
      delete video.dataset.played;
    });
  });

  let checks = 0;
  const interval = setInterval(() => {
    document.querySelectorAll('.kt-product-image__has-hover-video:not([data-observed])').forEach(card => {
      card.dataset.observed = 'true';
      preloadObserver.observe(card);
      mobileObserver.observe(card);
    });
    checks++;
    if (checks >= 10) clearInterval(interval);
  }, 500);

  const recContainer = document.querySelector('product-recommendations');
  if (recContainer) {
    new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const loadRecVideos = () => {
            const videos = recContainer.querySelectorAll('.kt-hover-video');
            if (videos.length === 0) {
              setTimeout(loadRecVideos, 300);
              return;
            }
            videos.forEach(video => {
              if (video.dataset.src && !video.src) {
                video.src = video.dataset.src;
                video.load();
              }
            });
          };
          loadRecVideos();
        }
      });
    }, { threshold: 0.1 }).observe(recContainer);
  }

  initSafariVideoFix();

});

new MutationObserver(() => {
  initSafariVideoFix();
}).observe(document.body, { childList: true, subtree: false });